'use strict';

angular.module('app.notification')
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home.profileNotificationCenter', {
                requireLogin: true,
                url: 'profile/notification',
                templateUrl: 'app/notification/notification.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User', 'Administrator'],
                    navMarker: ['profile', 'notification']
                },
                controller: 'NotificationCtrl'
            })
    }]);